<app-info-label *ngIf='isHybrid | async'>{{ 'queueView.monitorViewNotIncludeCX' | translate }}</app-info-label>
<div class="tab-selector" *ngIf="showLiveWorkloadTabs">
  <div class="active-tab-indicator" [ngClass]="activeTab + '-active'"></div>
  <div class="tab departments-tab" (click)="setActiveTab(liveWorkloadTab.DEPARTMENTS)">
    {{ 'liveWorkLoadTab.departments' | translate }}
  </div>
  <div class="tab agents-tab" (click)="setActiveTab(liveWorkloadTab.AGENTS)">
    {{ 'liveWorkLoadTab.agents' | translate }}
  </div>
</div>
<app-agent-list-tab [ngStyle]="{'margin-top': (isHybrid | async ) ? '0px' : '15px'}" [selectedDepartments]="selectedDepartments"
                    (navigateToOtherTab)="onNavigate($event)"
                    class="agent-list-tab"
                    *ngIf="activeTab === liveWorkloadTab.AGENTS || !showLiveWorkloadTabs"
>
</app-agent-list-tab>
<app-department-list-tab class="department-list-tab"
                         *ngIf="activeTab === liveWorkloadTab.DEPARTMENTS && showLiveWorkloadTabs"
                         [selectedDepartments]="selectedDepartments"
                         (navigateToAgentsTab)="onNavigateToAgentsTab($event)"
                         (navigateToOtherTab)="onNavigate($event)"
>
</app-department-list-tab>
